import React, { useState } from "react";
import cx from "classnames";

import SwitchButton from "src/components/switchButton";

import Card from "../card";
import { useDraft } from "../useDraft";
import { canEdit } from "src/pages/experiences/storyboardSettings/utils/permissions";
import styles from "./passwordProtectCard.module.scss";

const PasswordProtectCard: React.FC = () => {
  const { draft, setField } = useDraft();
  const [visible, setVisible] = useState(false);
  const enabled = Boolean(draft?.passwordEnabled);
  const editable = canEdit(draft?.role);
  const displayPassword = draft?.password ?? "";
  const hasHiddenPassword = enabled && !displayPassword;
  const placeholder = hasHiddenPassword ? "********" : "Enter your password";
  const hasPassword = Boolean(displayPassword) || enabled;

  const toggle = () => {
    if (!editable || !hasPassword) return;
    const next = !enabled;
    setField("passwordEnabled", next);
    if (!next) {
      setField("password", "");
    }
  };

  const handleChange = (value: string) => {
    setField("password", value);
    if (value && !enabled) setField("passwordEnabled", true);
    else if (!value && enabled) setField("passwordEnabled", false);
  };

  return (
    <Card
      title="Password Protect"
      description="Only visitors with this password will be allowed to access the published URL"
      style={{ overflow: "hidden" }}
      headerRight={
        <SwitchButton
          id="passwordProtectToggle"
          checked={enabled}
          handleCheck={toggle}
          disabled={!editable || !hasPassword}
        />
      }
    >
      <div className={cx(styles.field, { [styles.disabled]: !editable })}>
        <input
          type="text"
          className={cx(styles.input, {
            [styles.masked]: !visible && Boolean(displayPassword),
            [styles.starPlaceholder]: hasHiddenPassword,
          })}
          placeholder={placeholder}
          value={displayPassword}
          disabled={!editable}
          onChange={(e) => handleChange(e.target.value)}
          name="storyboard-password"
          autoComplete="off"
          data-1p-ignore
          data-lpignore="true"
          data-form-type="other"
        />
        {!hasHiddenPassword && (
          <button
            type="button"
            className={styles.eyeBtn}
            onClick={() => setVisible((v) => !v)}
            disabled={!editable}
            aria-label={visible ? "Hide password" : "Show password"}
          >
            <i className={cx(visible ? "paperflite-eye" : "paperflite-hidden-eye")} />
          </button>
        )}
      </div>
    </Card>
  );
};

export default PasswordProtectCard;
